import React from "react";
import ReactDOM from "react-dom/client";
import "@wix/design-system/styles.global.css";
import "@wix/design-system/themes/odeditor.global.css";
import "./index.css";
import "./i18n";
import App from "./App";
import { WdsProviders } from "./components/WdsProviders";
import reportWebVitals from "./reportWebVitals";
import { initAnalytics } from "./analytics";

initAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <WdsProviders>
      <App />
    </WdsProviders>
  </React.StrictMode>
);

reportWebVitals();
